const template = document.createElement('template');
template.innerHTML = `
<style>
    :host {
        position: absolute;
        bottom: 100px;
        left: 50%;
        transform: translateX(-50%);
        display: block;
        width: 95%; /* Responsive width */
        max-width: 1140px; /* Fits approx 3 octaves comfortably */
        background: rgba(0, 0, 0, 0.85);
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 12px;
        backdrop-filter: blur(12px);
        -webkit-backdrop-filter: blur(12px);
        box-shadow: 0 8px 32px rgba(0,0,0,0.6);
        user-select: none;
        z-index: 100;
        transition: max-height 0.3s cubic-bezier(0.4, 0.0, 0.2, 1), transform 0.1s linear, opacity 0.2s;
        overflow: hidden;
    }

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 15px;
        background: rgba(255, 255, 255, 0.08);
        cursor: grab;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        height: 40px;
    }

    .header:active {
        cursor: grabbing;
    }

    .title-group {
        display: flex;
        align-items: center;
        gap: 15px;
    }

    .title {
        font-family: 'Courier New', Courier, monospace;
        font-size: 0.9rem;
        font-weight: bold;
        color: #ddd;
        letter-spacing: 1px;
    }

    .controls {
        display: flex;
        align-items: center;
        gap: 5px;
        background: rgba(0,0,0,0.3);
        border-radius: 4px;
        padding: 2px;
        border: 1px solid rgba(255,255,255,0.1);
    }
    
    .range-toggle {
        font-family: 'Courier New', Courier, monospace;
        font-size: 0.65rem;
        background: transparent;
        border: 1px solid rgba(255,255,255,0.2);
        color: #aaa;
        padding: 2px 5px;
        border-radius: 3px;
        cursor: pointer;
        margin-right: 5px;
    }
    
    .range-toggle:hover {
        color: #fff;
        border-color: rgba(255,255,255,0.5);
    }

    .vel-control {
        display: flex;
        align-items: center;
        gap: 5px;
        margin-left: 10px;
        margin-right: 5px;
    }

    .vel-label {
        font-family: 'Courier New', Courier, monospace;
        font-size: 0.7rem;
        color: #aaa;
        font-weight: bold;
    }

    input[type=range].vel-slider {
        -webkit-appearance: none;
        width: 80px;
        height: 4px;
        background: rgba(255,255,255,0.2);
        border-radius: 2px;
        outline: none;
    }

    input[type=range].vel-slider::-webkit-slider-thumb {
        -webkit-appearance: none;
        width: 12px;
        height: 12px;
        background: var(--primary-color, #00ffcc);
        border-radius: 50%;
        cursor: pointer;
        margin-top: -4px;
    }

    .oct-btn {
        background: rgba(255,255,255,0.1);
        border: none;
        color: #eee;
        width: 24px;
        height: 24px;
        border-radius: 3px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        transition: background 0.2s;
    }

    .oct-btn:hover {
        background: rgba(255,255,255,0.3);
    }

    .oct-btn:active {
        background: var(--primary-color, #00ffcc);
        color: #000;
    }

    .oct-display {
        font-family: 'Courier New', Courier, monospace;
        font-size: 0.75rem;
        color: var(--primary-color, #00ffcc);
        min-width: 60px;
        text-align: center;
        font-weight: bold;
    }

    .fold-btn {
        background: transparent;
        border: none;
        color: #aaa;
        cursor: pointer;
        padding: 5px;
        display: flex;
        transition: transform 0.3s;
    }

    .fold-btn:hover {
        color: #fff;
    }

    :host(.folded) .fold-btn {
        transform: rotate(-90deg);
    }

    .keys-container {
        display: flex;
        height: 160px;
        padding: 5px;
        gap: 2px;
        transition: opacity 0.2s;
        position: relative;
    }

    :host(.folded) .keys-container {
        visibility: hidden;
        opacity: 0;
        pointer-events: none;
    }

    .keyboard-octave {
        display: flex;
        position: relative;
        flex: 1;
        gap: 1px;
    }
    
    .white-key {
        flex: 1;
        height: 100%;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 0 0 4px 4px;
        position: relative;
        cursor: pointer;
        box-shadow: inset 0 -2px 5px rgba(0,0,0,0.2);
        transition: background 0.05s;
    }
    
    .white-key:active, .white-key.active {
        background: var(--primary-color, #00ffcc);
        box-shadow: 0 0 15px var(--primary-color, #00ffcc);
        transform: translateY(1px);
    }

    .white-key .note-label {
        position: absolute;
        bottom: 5px;
        width: 100%;
        text-align: center;
        font-size: 0.6rem;
        color: rgba(0,0,0,0.5);
        pointer-events: none;
        font-weight: bold;
    }

    .black-key {
        position: absolute;
        top: 0;
        width: 12%; 
        height: 60%;
        background: linear-gradient(to bottom, #222, #000);
        border-radius: 0 0 3px 3px;
        z-index: 2;
        border: 1px solid #444;
        box-shadow: 2px 2px 5px rgba(0,0,0,0.5);
        cursor: pointer;
        transition: background 0.05s;
    }

    .black-key:active, .black-key.active {
        background: var(--primary-color, #00ffcc);
        box-shadow: 0 0 15px var(--primary-color, #00ffcc);
    }

    /* Positioning black keys (percent of octave width) */
    .bk-1 { left: 10%; } /* C# */
    .bk-2 { left: 26.5%; } /* D# */
    .bk-3 { left: 53%; } /* F# */
    .bk-4 { left: 69.5%; } /* G# */
    .bk-5 { left: 86%; } /* A# */

    @media (max-width: 600px) {
        .title { display: none; }
        .vel-control { display: none; } /* Hide velocity on small screens to save space */
        :host {
             width: 100%;
             max-width: 100%;
             border-radius: 12px 12px 0 0;
             left: 0;
             transform: none;
             bottom: 0;
             border-left: none;
             border-right: none;
        }
    }

</style>
<div class="header" id="header">
    <div class="title-group">
        <span class="title">KEYBOARD</span>
        <button class="range-toggle" id="range-toggle" title="Toggle Size">3 OCT</button>
        <div class="controls">
            <button class="oct-btn" id="oct-down" title="Octave Down">-</button>
            <span class="oct-display" id="oct-display">C3-B5</span>
            <button class="oct-btn" id="oct-up" title="Octave Up">+</button>
        </div>
        <div class="vel-control">
            <span class="vel-label">VEL</span>
            <input type="range" class="vel-slider" id="vel-slider" min="0" max="1" step="0.01" value="0.8">
        </div>
    </div>
    <button class="fold-btn" id="fold-btn">
        <svg viewBox="0 0 24 24" width="20" height="20"><path fill="currentColor" d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/></svg>
    </button>
</div>
<div class="keys-container" id="keys">
    <!-- Generated Keys will go here -->
</div>
`;

export class VirtualKeyboard extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(template.content.cloneNode(true));
        
        this.header = this.shadowRoot.getElementById('header');
        this.keysContainer = this.shadowRoot.getElementById('keys');
        this.foldBtn = this.shadowRoot.getElementById('fold-btn');
        this.octDownBtn = this.shadowRoot.getElementById('oct-down');
        this.octUpBtn = this.shadowRoot.getElementById('oct-up');
        this.octDisplay = this.shadowRoot.getElementById('oct-display');
        this.velSlider = this.shadowRoot.getElementById('vel-slider');
        this.rangeToggle = this.shadowRoot.getElementById('range-toggle');
        
        // State
        this.isDragging = false;
        this.dragOffset = { x: 0, y: 0 };
        this.collapsed = false;
        
        // Keyboard Configuration
        this.baseOctave = 3; // Starting octave
        this.numOctaves = 3; // Number of octaves to display
        this.velocity = 0.8;
        
        // Bindings
        this.foldBtn.addEventListener('click', (e) => {
            e.stopPropagation(); 
            this.toggleFold();
        });

        this.rangeToggle.addEventListener('click', (e) => {
            e.stopPropagation();
            this.toggleRange();
        });

        this.octDownBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.shiftOctave(-1);
        });

        this.octUpBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.shiftOctave(1);
        });


        this.velSlider.addEventListener('input', (e) => {
            e.stopPropagation(); // prevent drag
            this.velocity = parseFloat(e.target.value);
        });
        
        this.velSlider.addEventListener('mousedown', (e) => e.stopPropagation()); // prevent drag start
        this.velSlider.addEventListener('touchstart', (e) => e.stopPropagation(), {passive: true});

        this.header.addEventListener('mousedown', (e) => this.startDrag(e));
        this.header.addEventListener('touchstart', (e) => this.startDrag(e), {passive: false});

        window.addEventListener('mousemove', (e) => this.drag(e));
        window.addEventListener('touchmove', (e) => this.drag(e), {passive: false});
        
        window.addEventListener('mouseup', () => this.stopDrag());
        window.addEventListener('touchend', () => this.stopDrag());
        
        // Initial Render
        this.renderKeys();
    }
    
    toggleRange() {
        if (this.numOctaves === 3) {
            this.numOctaves = 2;
            this.rangeToggle.textContent = "2 OCT";
        } else {
            this.numOctaves = 3;
            this.rangeToggle.textContent = "3 OCT";
        }
        this.renderKeys();
    }

    getNoteFrequency(noteName) {
        // Parse note name (e.g., "C#4", "A3")
        const match = noteName.match(/([A-G]#?)(\d+)/);
        if (!match) return 0;
        
        const note = match[1];
        const octave = parseInt(match[2]);
        
        const notes = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];
        const semitoneIndex = notes.indexOf(note);
        
        // MIDI Note Number: C-1 = 0, C4 = 60, A4 = 69
        // Formula: NoteNum = (Octave + 1) * 12 + SemitoneIndex
        const midiNote = (octave + 1) * 12 + semitoneIndex;
        
        // Frequency Formula: f = 440 * 2^((d - 69)/12)
        return 440 * Math.pow(2, (midiNote - 69) / 12);
    }

    shiftOctave(delta) {
        const newOctave = this.baseOctave + delta;
        if (newOctave < 0 || newOctave > 7) return; // Limits
        
        this.baseOctave = newOctave;
        this.renderKeys();
        
        // Provide haptic/visual feedback if possible?
    }

    renderKeys() {
        this.keysContainer.innerHTML = '';
        const notes = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];
        
        for (let i = 0; i < this.numOctaves; i++) {
            const currentOctave = this.baseOctave + i;
            const octaveDiv = document.createElement('div');
            octaveDiv.className = 'keyboard-octave';
            
            // White Keys
            const whiteNotes = ['C', 'D', 'E', 'F', 'G', 'A', 'B'];
            whiteNotes.forEach(note => {
                const key = document.createElement('div');
                key.className = 'white-key';
                key.dataset.note = `${note}${currentOctave}`;
                
                // Add label for C keys or all? Let's do C keys
                if (note === 'C') {
                    const label = document.createElement('div');
                    label.className = 'note-label';
                    label.textContent = `C${currentOctave}`;
                    key.appendChild(label);
                }
                
                octaveDiv.appendChild(key);
            });
            
            // Black Keys
            const blackNotes = [
                { note: 'C#', pos: 'bk-1' },
                { note: 'D#', pos: 'bk-2' },
                { note: 'F#', pos: 'bk-3' },
                { note: 'G#', pos: 'bk-4' },
                { note: 'A#', pos: 'bk-5' }
            ];
            
            blackNotes.forEach(bn => {
                const key = document.createElement('div');
                key.className = `black-key ${bn.pos}`;
                key.dataset.note = `${bn.note}${currentOctave}`;
                octaveDiv.appendChild(key);
            });
            
            this.keysContainer.appendChild(octaveDiv);
        }
        
        // Update Display Text
        const startNote = `C${this.baseOctave}`;
        const endNote = `B${this.baseOctave + this.numOctaves - 1}`;
        this.octDisplay.textContent = `${startNote}-${endNote}`;
        
        this.setupKeyEvents();
    }

    setupKeyEvents() {
        const keys = this.shadowRoot.querySelectorAll('.white-key, .black-key');
        
        const handleStart = (e) => {
            e.preventDefault();
            e.stopPropagation();
            const target = e.target.closest('[data-note]');
            if (!target) return;
            
            const note = target.dataset.note;
            if (target.classList.contains('active')) return; // Already active (e.g. from slide)

            target.classList.add('active');
            
            const freq = this.getNoteFrequency(note);
            this.dispatchEvent(new CustomEvent('noteon', { 
                bubbles: true, 
                composed: true,
                detail: { note, freq, velocity: this.velocity, id: `key-${note}` } 
            }));
        };

        const handleEnd = (e) => {
            e.preventDefault();
            // Handle touch end logic carefully to avoid stuck notes
             const target = e.target.closest('[data-note]');
            if (!target) return;
            
            const note = target.dataset.note;
            target.classList.remove('active');
            
            this.dispatchEvent(new CustomEvent('noteoff', { 
                bubbles: true, 
                composed: true,
                detail: { note, id: `key-${note}` } 
            }));
        };

        const handleEnter = (e) => {
            // Support for glissando (sliding over keys)
            if (e.buttons === 1 || (e.touches && e.touches.length > 0)) {
                handleStart(e);
            }
        };
        
        const handleLeave = (e) => {
             const target = e.target.closest('[data-note]');
             if(target && target.classList.contains('active')) {
                 handleEnd(e);
             }
        }

        const handleTouchMove = (e) => {
            e.preventDefault(); // Prevent scrolling while playing
            const touch = e.changedTouches[0];
            const target = this.shadowRoot.elementFromPoint(touch.clientX, touch.clientY);
            
            if (target) {
                const key = target.closest('[data-note]');
                // If we moved to a new key
                if (key && !key.classList.contains('active')) {
                    // 1. Find and stop previously active key for this touch? 
                    // Simplified: We assume single touch glissando for now or let multi-touch work independently.
                    // But 'touchmove' fires on the *target where it started*.
                    // So we must manually trigger 'noteoff' for the old key if we left it.
                    
                    // Actually, simpler approach:
                    // Just trigger start on new key. 
                    // 'noteoff' for old key is tricky without tracking "current key under finger".
                    
                    // Let's track lastKey
                    if (this.lastKey && this.lastKey !== key) {
                        // Manually trigger end on lastKey
                        const oldNote = this.lastKey.dataset.note;
                        this.lastKey.classList.remove('active');
                        this.dispatchEvent(new CustomEvent('noteoff', { 
                            bubbles: true, 
                            composed: true,
                            detail: { note: oldNote, id: `key-${oldNote}` } 
                        }));
                    }
                    
                    // Trigger start on new key
                    const note = key.dataset.note;
                    key.classList.add('active');
                    const freq = this.getNoteFrequency(note);
                    this.dispatchEvent(new CustomEvent('noteon', { 
                        bubbles: true, 
                        composed: true,
                        detail: { note, freq, velocity: this.velocity, id: `key-${note}` } 
                    }));
                    
                    this.lastKey = key;
                } else if (!key && this.lastKey) {
                    // Moved off keyboard
                    const oldNote = this.lastKey.dataset.note;
                    this.lastKey.classList.remove('active');
                    this.dispatchEvent(new CustomEvent('noteoff', { 
                        bubbles: true, 
                        composed: true,
                        detail: { note: oldNote, id: `key-${oldNote}` } 
                    }));
                    this.lastKey = null;
                }
            }
        };

        keys.forEach(k => {
            // Mouse
            k.addEventListener('mousedown', handleStart);
            k.addEventListener('mouseup', handleEnd);
            k.addEventListener('mouseleave', handleLeave);
            k.addEventListener('mouseenter', handleEnter);
            
            // Touch
            k.addEventListener('touchstart', (e) => {
                handleStart(e);
                this.lastKey = e.target.closest('[data-note]');
            }, {passive: false});
            
            k.addEventListener('touchend', (e) => {
                handleEnd(e);
                this.lastKey = null;
            });
            
            k.addEventListener('touchmove', handleTouchMove, {passive: false});
            
            k.addEventListener('touchcancel', (e) => {
                handleEnd(e);
                this.lastKey = null;
            });
        });
    }

    toggleFold() {
        this.collapsed = !this.collapsed;
        if (this.collapsed) {
            this.classList.add('folded');
            this.style.maxHeight = '40px'; // Header height
        } else {
            this.classList.remove('folded');
            this.style.maxHeight = '210px'; // Keys + Header + Padding
        }
    }

    startDrag(e) {
        if (e.target.closest('.fold-btn') || e.target.closest('.controls')) return;
        this.isDragging = true;
        const rect = this.getBoundingClientRect();
        
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        const clientY = e.touches ? e.touches[0].clientY : e.clientY;

        this.dragOffset.x = clientX - rect.left;
        this.dragOffset.y = clientY - rect.top;
        this.style.cursor = 'grabbing';
    }

    drag(e) {
        if (!this.isDragging) return;
        e.preventDefault();
        
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        const clientY = e.touches ? e.touches[0].clientY : e.clientY;
        
        const x = clientX - this.dragOffset.x;
        const y = clientY - this.dragOffset.y;
        
        this.style.transform = 'none';
        this.style.left = `${x}px`;
        this.style.top = `${y}px`;
        this.style.bottom = 'auto';
    }

    stopDrag() {
        this.isDragging = false;
        this.style.cursor = 'default';
    }
}

customElements.define('virtual-keyboard', VirtualKeyboard);